import { createReducer, on } from '@ngrx/store';
import { RoleActions } from './roles.actions';
import { Role } from '@core/interface/roles';
import { Pagination } from '@core/interface/core';

export const RoleFeatureKey = 'role';

export interface RoleState {
  roles: Role[];
  isLoading: boolean;
  isDeleted: boolean;
  inviteLoading: boolean;
  isInvited: boolean;
  loadError?: any;
  deleteError?: any;
  inviteError?: any;
  addEditError?: any;
  pagination: Pagination;
  inviteResponse: any;
}

export const initialState: RoleState = {
  roles: [],
  isLoading: true,
  isDeleted: false,
  isInvited: false,
  inviteResponse: null,
  inviteLoading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const RoleReducer = createReducer(
  initialState,
  on(RoleActions.loadRoles, (state) => ({ ...state })),
  on(RoleActions.loadRolesSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    roles: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
  })),
  on(RoleActions.loadRolesFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(RoleActions.addRoleSuccess, (state, { data }) => ({
    ...state,
    roles: [...state.roles, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(RoleActions.addRoleFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(RoleActions.updateRoleSuccess, (state, { data }) => ({
    ...state,
    roles: state.roles.map((Role) => (data.id == Role.id ? data : Role)),
    isDeleted: false,
    addEditError: null,
  })),
  on(RoleActions.updateRoleFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(RoleActions.deleteRoleSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    roles: state.roles.filter((Role) => Role.id !== id),
  })),
  on(RoleActions.deleteRoleFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(RoleActions.deleteRole, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  }))
);
